import { useTranslation } from "react-i18next";
import { ForkKnifeIcon } from "./ForkKnifeIcon";

/**
 * Етикет „Обедно" до името на продукт от обедно меню — в каталога (плочки,
 * списък, търсене), в кошницата, в историята на масата и на мониторите.
 *
 * При изчерпан дневен лимит — „Изчерпано" (броят „N бр" е отделно, до
 * мерната единица — `LunchCount`).
 *
 * `inline` — етикетът седи ВЪТРЕ в текста на името (редът може да се пренася,
 * затова не е flex): `align-middle` слага средата му на средата на малките
 * букви, а -1px я вдига към средата на реда с главна буква — така средата на
 * етикета съвпада със средата на текста при всеки размер на шрифта. Без
 * `inline` родителят е flex с items-center и центрира сам.
 */
export const LunchTag = ({
  className = "",
  inline = false,
  soldOut = false,
}: {
  className?: string;
  inline?: boolean;
  /** Порциите за деня са свършили — „Изчерпано" в червено */
  soldOut?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex h-5 shrink-0 items-center gap-1 rounded-md border px-1.5 text-[11px] font-semibold leading-none ${
        soldOut
          ? "border-pos-danger-brd bg-pos-danger-bg text-pos-danger-ink"
          : "border-pos-accent/35 bg-pos-marked text-pos-accent-ink"
      } ${inline ? "align-middle -translate-y-px" : ""} ${className}`}
    >
      {!soldOut && <ForkKnifeIcon className="text-[10px]" />}
      {t(soldOut ? "lunchMenu.tagSoldOut" : "lunchMenu.tag")}
    </span>
  );
};

/**
 * „11 бр" — колко порции от обедния продукт остават за днес (минус кошницата);
 * 0 — в червено. Само за продукт с дневен лимит.
 */
export const LunchCount = ({ count, className = "" }: { count: number; className?: string }) => {
  const { t } = useTranslation();
  return (
    <span
      title={t("lunchMenu.remainingTitle", { count })}
      className={`shrink-0 whitespace-nowrap font-pos-mono font-bold ${
        count <= 0 ? "text-pos-danger-ink" : "text-pos-accent-ink"
      } ${className}`}
    >
      {t("lunchMenu.countLeft", { count })}
    </span>
  );
};
